<template>
  <div>
    <el-col :xs="24" :lg="24" :md="24" :sm="24">
      <template>
        <div class="block">
          <div class="progress">
            <template v-for="(item, index) in data.monitor_log">
              <div class="progress-row">
                <div style="width:24%;">
                  <p style="font-size: 16px;padding-bottom: 5px;">{{ item.crt_time.split(" ")[0] }}</p>
                  <p style="color:#666;line-height:1.5">{{ item.crt_time.split(" ")[1] }}</p>
                </div>
                <div style="flex:1">
                  <div class="comment-status-row">
                    <label style="font-size: 16px;margin-left:5px;">{{item.response }}</label>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </el-col>
  </div>
</template>

<script>

  let _ = require('lodash')

  export default {
    name: 'Collapse',
    props: ['data', 'type', 'columns', 'expressTypeOption', 'expressCompanyList', 'monitorTypeOption'],
    components: {},
    data() {
      return {}
    },
    async mounted() {

    },
    methods: {},
  }
</script>

<style lang="scss" scoped>
  .select-group {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & > div {
      display: flex;
      align-items: center;
      width: 45%;
    }
  }

  .tag-label {
    background: black;
    color: white;
    display: inline-block;
    height: 30px;
    padding: 0 5px;
    border-radius: 5px;
    line-height: 30px;
  }

  .progress-row {
    display: flex;
  }

  .progress {
    .progress-row {
      padding: 15px 0;
      border-top: 1px solid #DCDFE6;
    }
  }

  .relation {
    cursor: pointer;

    label {
      cursor: pointer;
    }

    .editIcon {
      cursor: pointer;
      display: none;
    }

    &:hover {
      .editIcon {
        display: inline-block;
      }
    }
  }

  .content-editable {
    border: 1px solid transparent;
    border-radius: 4px;
    min-height: 40px;
    display: block;
    cursor: pointer;

    .editIcon {
      cursor: pointer;
      display: none;
    }

    &.input {
      line-height: 40px;
      height: 40px;
    }

    &.textarea {
      line-height: 1.5;
      min-height: 21px;
    }

    &:hover {
      .editIcon {
        display: inline-block;
      }
    }
  }

  .info {
    margin-bottom: 10px;
  }

  .content_link {
    color: #303133;
  }

  .ticket-container {
    padding: 15px 0;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      padding-bottom: 0;
      border-bottom: none;
    }

    &.order {
      display: flex;
      justify-content: space-between;
    }
  }

  .ticket-wrapper {
    .product-wrapper-left.lika {
      margin-left: 237px;

      &.taskDisplay {
        margin-left: 200px;
      }
    }

    .product-wrapper-right {
      text-align: right;
    }

    &:last-child {
      margin-bottom: 0;
    }

    &.order {
      flex: 1;
      border-right: 1px solid #D7D7D7;
      padding-right: 25px;
      line-height: 1;
    }

    .product-wrapper-right.order p {
      color: #888888;
    }
  }

  .product-item {
    display: flex;
    height: 120px;
    margin-bottom: 30px;

    &:first-child {
      padding-top: 0;
    }

    &:last-child {
      border-bottom: 0;
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .product-detail {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      position: relative;
      top: -3px;
      margin-left: 20px;

      .product-name {
        font-size: 14px;
        color: #333333;
      }

      .product-price {
        line-height: 32px;
        color: black;

        label {
          font-size: 18px;
        }
      }

      .product-price del {
        font-size: 16px;
      }
    }
  }

  .product-price label.danger {
    font-size: 18px;
    color: #FF4650;
  }

  .priority-label {
    display: inline-block;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    position: relative;
    top: 1px;

    &.P1 {
      background-color: #FF4650;
    }

    &.P2 {
      background-color: #e6a23c;
    }

    &.P3 {
      background-color: #409eff;
    }

    &.P4 {
      background-color: #909399;
    }
  }

  .comment-status-row {
    display: flex;
    align-items: center;
    line-height: 20px;
    position: relative;
    top: -5px;

    .visible-view {
      display: inline-block;
    }

    .visible-edit {
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/orders/express_monitor/CollapseBody.vue